export default __webpack_public_path__ + "static/media/file.da8d6716.svg";